module.exports = __webpack_public_path__ + "fa-solid-900.b87b9ba532ace76ae9f6.ttf";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-solid-900.ttf
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-solid-900.ttf
// module chunks = styles